import apiClient from '@api/apiClient';

const getCalendar = async ({before_date, after_date}) => {
  try {
    const response = await apiClient.get(
      `calendar?before_date=${before_date}&after_date=${after_date}`,
      {middleware: {withAuth: true}},
    );
    const {data} = response || {};
    return data;
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

export {getCalendar};
